export interface IOpoDocument {
    documentTypeId: number,
    name: string,
    hasFile: boolean,
    uploadedOn: string | null,
    uploadedByName: string | null
}

export interface IOpoSaveResult {
    success: boolean,
    message: string
}
